export default "__VITE_ASSET__CMFTc_oc__"